import { PayloadAction } from '@reduxjs/toolkit';
import {
  ShapeValidation,
  ShapeValidationState,
  RingValidationInput,
  DiscValidationInput,
  FrameValidationInput,
  StripValidationInput,
} from './types';
import { initialState } from './index';

export const reducers = {
  validateRing(
    state: ShapeValidationState,
    action: PayloadAction<RingValidationInput>,
  ) {
    state.isLoading = true;
  },
  validateDisc(
    state: ShapeValidationState,
    action: PayloadAction<DiscValidationInput>,
  ) {
    state.isLoading = true;
  },
  validateFrame(
    state: ShapeValidationState,
    action: PayloadAction<FrameValidationInput>,
  ) {
    state.isLoading = true;
  },
  validateStrip(
    state: ShapeValidationState,
    action: PayloadAction<StripValidationInput>,
  ) {
    state.isLoading = true;
  },
  validateShapeSuccess(
    state: ShapeValidationState,
    action: PayloadAction<ShapeValidation>,
  ) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  validateShapeFail(
    state: ShapeValidationState,
    action: PayloadAction<unknown>,
  ) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
